import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({ onSizeGuideClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="navigation-header">
      <div className="navigation-logo">LN</div>
      
      <nav className={`navigation-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <a className="navigation-link" onClick={() => scrollToSection('about')}>About</a>
        <a className="navigation-link" onClick={() => scrollToSection('shows')}>Shows</a>
        <a className="navigation-link" onClick={onSizeGuideClick}>Event Guide</a>
        <a className="navigation-link" onClick={() => scrollToSection('testimonials')}>Testimonials</a>
      </nav>

      <div className="navigation-utilities">
        <button className="btn-primary" style={{ minWidth: '160px', height: '48px', padding: '12px 20px' }} onClick={() => scrollToSection('newsletter')}>
          Contact
        </button>
        
        <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
};

export default Header;